import { useLocation } from "react-router-dom";
import { Flex, Image, useMediaQuery, Link } from "@chakra-ui/react";
import { useAuth } from "hooks/useAuth";
import logoPrograma from "assets/programa/logo-programa.png";
import {PROGRAMA} from '../../vars';

interface SecondHeaderProps {
  isCategoryPage?: boolean;
}

export const SecondHeader = ({ isCategoryPage }: SecondHeaderProps) => {
  const [isMobileSize] = useMediaQuery("(max-width: 992px)");
  const location = useLocation();
  const parseLocation = location?.pathname?.split("/");
  const { dataUser } = useAuth();

  const pathName = parseLocation
    .map((item) => {
      const locationName = item?.split("-").join(" ");
      const parsedName =
        locationName.charAt(0).toUpperCase() + locationName.slice(1);
      return parsedName;
    })
    ?.filter((item) => item !== "" && item !== "Categoria");


    if (dataUser) 
      return null

  return (
    <>
      <Flex
        marginTop={isMobileSize ? "-20px" : "-20px"}
        width="100%"
        backgroundColor="#FFF"
        height={isMobileSize ? "90px" : "140px"}
        alignItems="center"
        justifyContent="center"
        paddingY={isMobileSize ? "10px" : "20px"}
        top={0}
        zIndex={999}
      >
        <Link href="/">
          <Image
            src={logoPrograma}
            alt={`Logo do ${PROGRAMA}`}
            height={ isMobileSize ? "auto" : "auto"}
            width={isMobileSize ? "180px" : "220px"}
            // zIndex={999999}
            position={'relative'}
            top={isMobileSize ? "20px" : "10px"}
          />
        </Link>
      </Flex>
    </>
  );
};
